<template>
  <div class="cartContainer" v-if="currentType == 1">
    <div class="cartListBox">
      <div class="title">{{ $t("reservation.yuyuegouwuche") }}</div>
      <el-button type="success" plain @click="$router.push('/')">{{
        $t("reservation.yuyueshangpinliebiao")
      }}</el-button>
      <div class="cartTitle">{{ $t("reservation.yuyuexinxitianxie") }}</div>
      <div class="reservationForm" style="margin: 10px 0">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          :rules="rules"
          label-width="130px"
        >
          <el-form-item
            :label="$t('reservation.goumaifangfa')"
            prop="buyMethod"
          >
            <el-select v-model="ruleForm.buyMethod">
              <el-option label="到店" value="到店"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('reservation.zhifufangfa')" prop="payMethod">
            <el-select v-model="ruleForm.payMethod">
              <el-option label="店頭現金" value="店頭現金"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('reservation.shopping')" prop="shopping">
            <el-select v-model="ruleForm.shopping">
              <el-option label="大塚本部" value="大塚本部"></el-option>
              <el-option label="秋葉原店 " value="秋葉原店"></el-option>
              <el-option label="池袋店" value="池袋店"></el-option>
              <el-option label="新宿店" value="新宿店"></el-option>
              <el-option label="なんば店" value="なんば店"></el-option>
              <el-option label="秋葉原本店" value="秋葉原本店"></el-option>
              <el-option label="なんば倉庫" value="なんば倉庫"></el-option>
              <el-option label="東川口物流センター" value="東川口物流センター"></el-option>
              <el-option label="東川口店" value="東川口店"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('reservation.fapiao')" prop="invoice">
            <el-radio-group v-model="ruleForm.invoice">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('reservation.xingming')" prop="name">
            <el-input v-model="ruleForm.name" style="width: 220px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('reservation.xingbie')" prop="sex">
            <el-radio-group v-model="ruleForm.sex">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('reservation.youxiang')" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('reservation.dizhi')" prop="address">
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('reservation.huikuandizhi')"
            prop="remittanceAddress"
          >
            <el-input v-model="ruleForm.remittanceAddress"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankName')"
              prop="inputBankName"
          >
            <el-input v-model="ruleForm.inputBankName"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankCode')"
              prop="inputBankCode"
          >
            <el-input v-model="ruleForm.inputBankCode"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankBranchName')"
              prop="inputBankBranchName"
          >
            <el-input v-model="ruleForm.inputBankBranchName"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankBranchCode')"
              prop="inputBankBranchCode"
          >
            <el-input v-model="ruleForm.inputBankBranchCode"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankAccNumber')"
              prop="inputBankAccNumber"
          >
            <el-input v-model="ruleForm.inputBankAccNumber"></el-input>
          </el-form-item>
          <el-form-item
              :label="$t('reservation.inputBankAccName')"
              prop="inputBankAccName"
          >
            <el-input v-model="ruleForm.inputBankAccName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('reservation.inputBankAccType')" prop="inputBankAccType">
            <el-radio-group v-model="ruleForm.inputBankAccType">
              <el-radio :label="$t('reservation.inputBankAccTypeSavings')">{{$t('reservation.inputBankAccTypeSavings')}}</el-radio>
              <el-radio :label="$t('reservation.inputBankAccTypeCurrent')">{{$t('reservation.inputBankAccTypeCurrent')}}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{
              $t("button.sure")
            }}</el-button>
            <el-button @click="resetForm('ruleForm')">{{
              $t("button.chongzhi")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="totalContainer">
      <div class="allMount">
        <div class="allMountTitle">
          {{ $t("category.yuyuefanhao") }}：{{ tagNumber }}
        </div>
        <div>{{ $t("category.hejijine") }}</div>
        <div class="allMountPrice">￥{{ allCount }}</div>
        <div>{{ $t("category.shuliang") }}：{{ buyCount }}</div>
      </div>
    </div>
  </div>
  <el-card class="successBox" v-else>
    <el-result icon="success" :title="$t('reservation.dingdantijiaochenggong')">
    </el-result>
    <el-descriptions
      :title="$t('reservation.dingdanxinxi')"
      direction="vertical"
      :column="2"
      border
    >
      <el-descriptions-item :label="$t('reservation.dingdanbianhao')">{{
        buyNumer
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('reservation.riqi')">{{
        date
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('reservation.jine')">{{
        priceAll
      }}</el-descriptions-item>
      <el-descriptions-item :label="$t('reservation.goumaishuliang')">
        {{ sucBuyCount }}
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin: 50px 0 0; text-align: center">
      <el-button type="success" plain disabled>状态:{{
          format(confirmStatus)
        }}</el-button>
    </div>
    <div style="margin: 50px 0 0; text-align: center">
      <el-button type="success" plain @click="$router.push('/')">{{
        $t("button.fanhui")
      }}</el-button>
    </div>
  </el-card>
</template>

<script>
import { addOrder } from "@/api/reservation";
export default {
  components: {},
  data() {
    return {
      currentType: 1, // 1: 预约 2: 订单详情
      tagNumber: "",
      allCount: 0, // 总价
      buyCount: 0,
      spuList: null,
      ruleForm: {
        buyMethod: "",
        payMethod: "",
        invoice: "否",
        name: "",
        sex: "男",
        email: "",
        address: "",
        remittanceAddress: "",
        shopping: "大塚本部",
        inputBankName: "",
        inputBankCode: "",
        inputBankBranchName: "",
        inputBankBranchCode: "",
        inputBankAccNumber: "",
        inputBankAccName: "",
        inputBankAccType: "普通",
      },
      rules: {
        buyMethod: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") + this.$t("reservation.goumaifangfa"),
            trigger: "change",
          },
        ],
        payMethod: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") + this.$t("reservation.zhifufangfa"),
            trigger: "change",
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("register.email"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("rules.qingxuanze") + this.$t("reservation.dizhi"),
            trigger: "blur",
          },
        ],
        remittanceAddress: [
          {
            required: true,
            message:
              this.$t("rules.qingxuanze") + this.$t("reservation.huikuandizhi"),
            trigger: "blur",
          },
        ],
      },

      // 订单成功信息
      buyNumer: 1,
      date: "2024 - 01 - 01",
      priceAll: "100.00",
      sucBuyCount: "5",
      confirmStatus: "0",
    };
  },

  created() {
    let { allCount, buyCount, orderId, spuList } = this.$route.query;
    this.buyCount = buyCount;
    this.allCount = allCount;
    this.tagNumber = orderId;
    this.spuList = spuList;
  },
  mounted() {
    // 设置定时器，‌每隔10秒执行一次this.refreshOrder
    this.intervalId = setInterval(this.refreshOrder(), 10000);
  },
  beforeDestroy() {
    // 清理定时器
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    format(status){
      if (status === '0') {
        return '已预约'
      } else if (status === '1') {
        return '审核中'
      } else {
        return '已结算'
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            orderId: this.tagNumber,
            spuNumber: this.buyCount,
            price: this.allCount,
            spuList: this.spuList,
            ...this.ruleForm,
          };
          addOrder(data).then((res) => {
            // console.log(res);
            this.buyNumer = res.data.orderId;
            this.date = res.data.createTime;
            this.priceAll = res.data.price;
            this.sucBuyCount = res.data.spuNumber;
            this.confirmStatus = res.data.confirmStatus;
            this.currentType = 2;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    refreshOrder(){
      let data = {
        orderId: this.tagNumber,
        spuNumber: this.buyCount,
        price: this.allCount,
        spuList: this.spuList,
        ...this.ruleForm,
      };
      addOrder(data).then((res) => {
        // console.log(res);
        this.confirmStatus = res.data.confirmStatus;
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style scoped lang='less'>
.cartContainer {
  display: flex;
  width: 65vw;
  min-height: calc(100vh - 42px);
  margin: 0 auto;
  background-color: #f5f7f9;
  box-sizing: border-box;
}
.cartTitle {
  font-size: 14px;
  padding: 10px;
  background-color: #fff;
  color: #cf3d3d;
  margin-top: 10px;
  font-weight: 600;
}
.cartListBox {
  width: 65%;
  padding: 20px 10px;
  .title {
    font-size: 30px;
    color: rgb(24, 212, 71);
    margin-bottom: 20px;
  }
}
.reservationForm {
  background-color: #fff;
  padding: 10px 20px 10px 0;
  box-sizing: border-box;
}
.totalContainer {
  position: relative;
  width: 32%;
  height: 345px;
  background-color: #fff;
  padding: 20px 10px;
  margin-top: 130px;
  box-sizing: border-box;
  .allMount {
    text-align: center;
    line-height: 2.5;
  }
  .allMountTitle {
    font-size: 20px;
    color: #11848e;
  }
  .allMountPrice {
    font-size: 25px;
    color: #f00;
  }
}
.successBox {
  width: 40%;
  margin: 100px auto 0;
}
@media screen and (max-width: 768px) {
  .cartContainer {
    width: 100vw;
    flex-direction: column;
  }
  .cartListBox {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      color: rgb(24, 212, 71);
      margin-bottom: 10px;
    }
  }
  .totalContainer {
    position: relative;
    width: 100%;
    height: 130px;
    background-color: #fff;
    padding: 10px;
    margin-top: 0px;
    box-sizing: border-box;
    .allMount {
      font-size: 14px;
      text-align: center;
      line-height: 1.8;
    }
    .allMountTitle {
      font-size: 16px;
      color: #11848e;
    }
    .allMountPrice {
      font-size: 16px;
      color: #f00;
    }
  }
  .successBox {
    width: 90%;
    margin: 50px auto 0;
  }
}
@media all and (min-width: 768px) and (max-width: 1199px) {
  .cartContainer {
    width: 95vw;
  }
  .successBox {
    width: 90%;
    margin: 50px auto 0;
  }
}
</style>